import {
  Dialog,
  DialogTitle,
  DialogContent,
  Box,
  Typography,
  IconButton
} from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import QuickActionsCore from './QuickActionsCore';

/**
 * QuickActionsModal - Modal wrapper for Quick Actions functionality
 * Uses shared QuickActionsCore component
 */
export default function QuickActionsModal({ open, onClose, currentJob = null }) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: { minHeight: '60vh', maxHeight: '90vh' }
      }}
    >
      <DialogTitle>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography variant="h5">Quick Actions</Typography>
          <IconButton onClick={onClose} size="small">
            <CloseIcon />
          </IconButton>
        </Box>
        {currentJob && (
          <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
            Current Job: {currentJob.name || currentJob.id}
          </Typography>
        )}
      </DialogTitle>

      <DialogContent dividers>
        <QuickActionsCore preselectedJob={currentJob} compact={true} />
      </DialogContent>
    </Dialog>
  );
}
